import { CircularProgress, IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import React from 'react';
import Box from '../../../../../../../../../Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

export default function DocumentsTablePagination({
  loading,
  onNext,
  onPrevious,
}) {
  return <>
    <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
      <CircularProgress size={'1em'} style={{ visibility: loading ? 'visible' : 'hidden' }} />
      <IconButton
        disabled={!onPrevious}
        onClick={onPrevious}
        icon={ChevronLeftIcon}
        color={'darkGray'}
      />
      <IconButton
        disabled={!onNext}
        onClick={onNext}
        icon={ChevronRightIcon}
        color={'darkGray'}
      />
    </Box>
  </>;
}
